"use strict";

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const sliderClose = () => {
    document.querySelectorAll(".close").forEach((section) => {
        const prevBtn = section.querySelector(".arrows-prev");
        const nextBtn = section.querySelector(".arrows-next");
        const sliderEl = section.querySelector(".close-slider");

        if (!sliderEl) return;

        new Swiper(sliderEl, {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 20,
            speed: 1000,
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            }
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    sliderClose();
});